import Fetch from '@helpers/Fetch';
import { useMutation, UseMutationResult } from 'react-query';

export default function useSendDownloadReminderEmail(): UseMutationResult<void, unknown, string> {
  return useMutation(email => Fetch.post('/api/public/send-download-reminder-email', { email }));
}
